<template>
  <div class="evaluation-form">
    <el-table :data="teacherEvaluationList" border :cell-style="{ 'text-align': 'center' }"
      :header-cell-style="{ 'background-color': '#0066cc', 'color': '#fff', 'text-align': 'center' }">
      <el-table-column prop="teacherName" label="教师名称" width="180">
      </el-table-column>
      <el-table-column prop="status" label="状态" width="180">
      </el-table-column>
      <el-table-column prop="questionType" label="评价类型">
        <template slot-scope="scope">
          {{
            (teacherTypeOptions.find(item => item.dictValue == scope.row.questionType) || {})
              .dictLabel || '未知'
          }}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="150px">
        <template slot-scope="scope">
          <div class="handle-container">
            <el-button v-if="scope.row.status === '未评价' && isOpen" type="success" size="small" @click="assessClick(scope.row)">评定
            </el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!-- 评定弹窗 -->
    <assessDialog v-show="assessDialogShow" :assessDialogShow.sync="assessDialogShow"
      :teacherProblemList="teacherProblemList" :studentForm="studentForm" :assessData="assessData"
      :schoolInfo="schoolInfo" :submitDataChild="submitDataChild" @submitData="submitData" />
  </div>
</template>

<script>
import assessDialog from "../assess-dialog/assessDialog.vue";
export default {
  components: {
    assessDialog
  },
  props: ['teacherEvaluationList', 'schoolInfo', 'studentForm', 'teacherTypeOptions', 'isOpen'],
  data() {
    return {
      data: [],
      assessDialogShow: false,
      assessData: {},
      teacherProblemList: [], // 指定类型教评问题列表
      submitDataChild: []
    }
  },
  methods: {
    assessClick(data) {
      this.getTeacherProblemList(data);
      this.assessData = data;
    },
    getTeacherProblemList(questionInfo) {
      this.submitDataChild = [];
      let data = {
        schoolId: this.user.schoolId,
        questionType: questionInfo.questionType
      };
      this.get(this.$url.selectTeacherEvaluation, data).then(res => {
        if (res.code !== 200) return;
        if (!res.data.length) return this.$message.warning("暂无问题，请联系教师或管理员前往教师管理-标准制定设置！");
        this.teacherProblemList = res.data;
        let { schoolYear, semester } = this.schoolInfo;
        let { studentName, studentNumber, id } = this.user;
        this.teacherProblemList.forEach(item => {
          // item.val = '';
          // console.log("item:", item);
          this.submitDataChild.push({
            evaluationId: item.id,
            optionId: "",
            teacherId: this.assessData.teacherId,
            studentId: id,
            schoolYear,
            semester
          })
        })
        this.assessDialogShow = true;
        // console.log("this.teacherProblemList:", this.teacherProblemList);

      })
    },
    submitData(data) {
      this.$emit('submitData', data)
    }
  }
};
</script>

<style lang="scss" scoped>
@import "./evaluationForm.scss";
</style>